import { Navigation, Pagination, Autoplay, EffectFade, Swiper } from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import { throttle } from "../components/setting";

export function service() {


}
